import React from 'react';
import PropTypes from 'prop-types';
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';

export function PendingFurtherReviewScreenError({ isMatchingVIN = false, isPreVinFlow = false }) {
  return (
    <div
      data-tracking-parent={updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: 'pending_further_review' })}
    >
      <h4 className="size-20 mb-2 text-center fw-normal">
        Capital One has received your online application for auto financing.
      </h4>
      <div className="d-flex justify-content-center mb-2">
        <p className="info-wrapper pending-further-review p-1 bg-gray-extra-light mb-0">
          We&apos;re still reviewing your application and Capital One may need more information. You may receive a call
          from Capital One if additional information is needed.
        </p>
      </div>
    </div>
  );
}

PendingFurtherReviewScreenError.propTypes = {
  isMatchingVIN: PropTypes.bool,
  isPreVinFlow: PropTypes.bool,
};
